import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareDataClassificationsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-data-classifications',
	path: '/jira/software/projects/:projectKey/settings/data-classifications',
	exact: true,
};
